<template>
  <div class="Page" :s="selected" v-if="options.length">
    <div
      class="Modal"
      v-if="modalShare || shShareMethodsMobile || storySuccess"
      :ehide="!!((modalShare < .5 && modalShare) || (shShareMethodsMobile < .5 && shShareMethodsMobile) || (storySuccess < .5 && storySuccess))"
    >
      <div class="MOverlay" @click="closeModals" :bactive="modalOverlayBlockActive"></div>
      <div class="MBox ModalShare" v-if="modalShare">
        <div class="MClose" @click="closeModals"></div>
        <div
          class="MTitle"
        >Расскажите друзьям о своём фаворите и получите 3 уникальных стикера в дополнение к набору фестиваля</div>
        <div
          class="MSnippetBox"
          :style="{
            backgroundImage:`url(/static/share${selected}.png)`
          }"
        ></div>
        <button class="Share" @click="shShareMethods = !shShareMethods">Поделиться</button>
        <button class="ShareMobile" @click="showShareMethodsMobile">Поделиться</button>
        <div class="ShareMethods" v-if="shShareMethods">
          <div class="SMethod" @click="share(0)">Опубликовать в истории</div>
          <div class="SMethod" @click="share(1)">Поделиться на стене</div>
        </div>
      </div>
      <div class="SelectShareMethodMobile" v-if="shShareMethodsMobile" :ios="ios">
        <div class="SHMethods">
          <div @click="share(0)">Опубликовать в истории</div>
          <div @click="share(1)">Поделиться на стене</div>
        </div>
        <div class="SHCancel" @click="hideShareMethodsMobile">Отменить</div>
      </div>
      <div class="MBox ModalStorySuccess" v-if="storySuccess">
        <div class="MClose" @click="storySuccessClose"></div>
        <div class="StoryCamIcon"></div>
        <span>История опубликована</span>
        <button class="BClose" @click="storySuccessClose">Закрыть</button>
      </div>
    </div>
    <div class="Title">Выборы талисмана</div>
    <div class="Options" :selectable="info.state == 0">
      <div
        class="Option"
        v-for="option in options"
        :key="option.id"
        @click="select(option.id)"
        :selected="selected == option.id"
        :style="{
          backgroundColor: `#${option.color[0]}`
        }"
        :blue="option.color[0] == '0102F8'"
      >
        <div
          class="Img"
          :style="{
            // backgroundImage: 'url(/static/example@x1.png)' // option.img
            backgroundImage: `url(https://vk.com/sticker/1-${option.img}-512b)` // option.img
          }"
        ></div>
        <div class="InfoBlock">
          <div class="OTitle">{{ option.title }}</div>
          <div class="ODescr">{{ option.descr }}</div>
          <div
            class="SelectCheckBoxMobile"
            v-if="info.state == 0"
            :style="{
              borderColor: `#${option.color[4]}`,
              color: `#${option.color[4]}`,
              backgroundColor: selected == option.id ? `#${option.color[4]}` : 'transparent'
            }"
          >
            <check
              :color="`#${selected == option.id ? option.color[0] == '0102F8' ? '0102F8' : 'fff' : option.color[4]}`"
            />Выбрать
          </div>
          <div
            class="ReslutBoxMobile"
            v-else-if="info.state == 1"
            :style="{
            color: `#${option.color[4]}`
          }"
          >
            <div class="Reslut">
              <div class="Percent">{{ option.percent }} %</div>
              <div class="Rate">
                {{ selected == option.id ? 'вы и ' : '' }}{{ option.votes }}
                <hicon :color="`#${option.color[4]}`"/>
              </div>
            </div>
          </div>
        </div>
        <div class="SelectCheckBox" v-if="info.state == 0"></div>
        <div
          class="ReslutBox"
          v-else-if="info.state == 1"
          :style="{
            color: `#${option.color[4]}`
          }"
        >
          <div class="Reslut">
            <div class="Percent">{{ option.percent }} %</div>
            <div class="Rate">
              {{ selected == option.id ? 'вы и ' : ''}}{{ option.votes }}
              <hicon :color="`#${option.color[4]}`"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- div class="Actions" :mshow="!!selected" :ios="ios">
      <button
        class="Vote"
        v-if="info.state == 0"
        @click="send"
        :disabled="!selected"
      >Подтвердить голос</button>
      <button class="Stickers" v-else-if="info.state == 1" @click="openShareModal">Получить стикеры</button>
    </div-->
    <div
      class="StorySuccessMobile"
      :ehide="storySuccessMobile < .5"
      v-if="storySuccessMobile"
    >История опубликована</div>
  </div>
</template>

<script>
import axios from "axios";
import connect from "@vkontakte/vkui-connect-promise";
import _connect from "@vkontakte/vkui-connect";
import hicon from "../assets/hicon";
import check from "../assets/check";

window.cc = connect;

export default {
  components: {
    hicon,
    check
  },
  name: "page-Vote",
  computed: {
    info() {
      return this.$root.info;
    },
    options() {
      return this.$root.options;
    }
  },
  data() {
    _connect.subscribe(async e => {
      if (e.detail && e.detail.type == "VKWebAppAccessTokenReceived") {
        if (e.detail.data.access_token) {
          const {
            data: {
              response: { upload_url }
            }
          } = await connect.send("VKWebAppCallAPIMethod", {
            method: "stories.getPhotoUploadServer",
            params: {
              add_to_news: 1,
              link_text: "vote",
              link_url: "https://vk.com/app6945371",
              v: "5.95",
              access_token: e.detail.data.access_token
            }
          });

          const {
            data: { response }
          } = await axios.get(`${window.host}/api/postStory`, {
            params: {
              upload_url,
              si: 0
            }
          });

          if (window._isMobile) {
            this.storySuccessMobile = 0.1;

            setTimeout(() => {
              this.storySuccessMobile = 1;
            }, 100);

            setTimeout(() => {
              this.storySuccessMobile = 0.1;

              setTimeout(() => {
                this.storySuccessMobile = 0;
              }, 1000);
            }, 5000);
          } else {
            this.storySuccess = 1;
          }

          this.shareSuccess(1);

          console.log(response);
        }
      }
    });

    return {
      err: "null",

      selected: null,
      modalShare: 0,
      shShareMethods: 0,
      shShareMethodsMobile: 0,
      modalNames: ["modalShare", "shShareMethods", "shShareMethodsMobile"],
      modalOverlayBlockActive: false,

      ios: window._isIphone,

      storySuccess: 0,
      storySuccessMobile: 0
    };
  },
  created() {
    if (this.$root.info.my) {
      this.selected = this.$root.info.my;
    }

    if (window._isMobile) {
      connect.send("VKWebAppSetViewSettings", {
        status_bar_style: "dark",
        action_bar_color: "#fff"
      });
    } else {
      connect.send("VKWebAppResizeWindow", {
        width: 660,
        height: 630 //716
      });
    }
  },
  methods: {
    closeModals() {
      this.modalNames.forEach(name => {
        if (this[name] === true || this[name] === 1) {
          this[name] = 0.1;

          setTimeout(() => {
            this[name] = 0;
          }, 60);
        }
      });
    },
    storySuccessClose() {
      this.storySuccess = 0;
    },
    showShareMethodsMobile() {
      this._tap();

      this.shShareMethodsMobile = 0.1;
      this.modalOverlayBlockActive = true;
      this.modalShare = 0;

      setTimeout(() => {
        this.shShareMethodsMobile = 1;
        this.modalOverlayBlockActive = false;
      }, 60);
    },
    hideShareMethodsMobile() {
      this.shShareMethodsMobile = 0.1;
      this.modalShare = 0.1;

      setTimeout(() => {
        this.shShareMethodsMobile = 0;
        this.modalShare = 1;
      }, 60);
    },
    select(id) {
      if (this.$root.info.state == 0) {
        this.selected = id;

        this._tap();
      }
    },
    async send() {
      if (!this.selected) {
        return;
      }

      this.$root.info.state = 1;

      const {
        data: { response }
      } = await axios.get(`${window.host}/api/vote`, {
        params: {
          id: this.selected
        }
      });

      this._tap();

      this.$root.processOptions(response.options, this.selected);
      this.openShareModal();

      // this.selected = null;
    },
    _tap() {
      connect.send("VKWebAppTapticImpactOccurred", {
        style: "heavy"
      });
    },
    openShareModal() {
      this._tap();

      this.shShareMethods = 0;
      this.modalShare = 0.1;

      setTimeout(() => {
        this.modalShare = 1;
      }, 60);
    },
    async shareSuccess(method) {
      const {
        data: { response }
      } = await axios.get(`${window.host}/api/shareSuccess`, {
        params: {
          method
        }
      });

      this._tap();
    },
    async share(method) {
      this._tap();

      this.modalShare = 0;
      this.shShareMethodsMobile = 0;

      if (method == 0) {
        _connect.send("VKWebAppGetAuthToken", {
          app_id: 6945371,
          scope: "stories"
        });

        /* const resp = await connect
          .send("VKWebAppGetAuthToken", {
            app_id: 6945371,
            scope: "stories"
          })
          .catch(err => {
            console.error(err);
            this.err += "\nError:" + JSON.stringify(err);

            return null;
          });

        this.err += "VKWebAppGetAuthToken: " + JSON.stringify(resp);

        console.log(resp);

        if (resp) {
          const {
            data: {
              response: { upload_url }
            }
          } = await connect.send("VKWebAppCallAPIMethod", {
            method: "stories.getPhotoUploadServer",
            params: {
              add_to_news: 1,
              link_text: "vote",
              link_url: "https://vk.com/app6945371",
              v: "5.95",
              access_token: resp.data.access_token
            }
          });

          const {
            data: { response }
          } = await axios.get(`${window.host}/api/postStory`, {
            params: {
              upload_url,
              si: 0
            }
          });

          if (window._isMobile) {
            this.storySuccessMobile = 0.1;

            setTimeout(() => {
              this.storySuccessMobile = 1;
            }, 100);

            setTimeout(() => {
              this.storySuccessMobile = 0.1;

              setTimeout(() => {
                this.storySuccessMobile = 0;
              }, 1000);
            }, 5000);
          } else {
            this.storySuccess = 1;
          }

          console.log(response);
        } */
      } else if (method == 1) {
        await connect.send("VKWebAppShowWallPostBox", {
          message: `Я получу уникальные стикеры, потому что проголосовал${
            this.$root.user.sex == 1 ? "а" : ""
          } за новый символ VK Fest! Выборы идут 20 и 21 мая — вы ещё успеваете! 

#СимволVKFest5`,
          attachments: "https://vk.com/app6945371",
          link_button: "open_url",
          link_image: `https://fest2k19.vkforms.ru/static/share${
            this.selected
          }.png`,
          link_title: "Символ VK Fest 5"
        });

        this.shareSuccess(1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.Page {
  .Modal {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    display: flex;
    opacity: 1;
    transition: 0.1s;

    .MOverlay {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.6);
    }

    .MBox {
      margin: auto;
      background-color: #fff;
      border-radius: 8px;
      z-index: 11;
      position: relative;

      .MClose {
        background-repeat: no-repeat;
        background-position: center;
        background-image: url(../assets/close.svg);
        width: 24px;
        height: 24px;
        cursor: pointer;
        position: absolute;
        top: 20px;
        right: 20px;

        &:hover {
          opacity: 0.8;
        }
      }

      .MTitle {
        font-family: SFProText-Medium;
        font-size: 16px;
        color: #222222;
        letter-spacing: -0.32px;
        text-align: center;
        line-height: 22px;
        max-width: 388px;
        margin: 20px auto;
      }

      .MSnippetBox {
        width: 450px;
        height: 201px;
        border-radius: 6px;
        margin: auto;
        // background-color: #0102f8;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        // background-size: cover;
      }
    }

    &[ehide] {
      .MOverlay,
      .MBox {
        opacity: 0;
      }

      .MOverlay[bactive] {
        opacity: 1;
      }

      .SelectShareMethodMobile {
        transform: translateY(340px);
      }

      &:not([ehide]) {
        .SelectShareMethodMobile {
          transition: 0.5;
          transform: translateY(0);
        }
      }
    }
  }

  .ModalShare {
    width: 500px;
    height: 387px;

    .Share {
      margin: 25px auto;
      display: block;
    }

    .ShareMethods {
      width: 180px;
      // height: 78px;
      border-radius: 8px;
      background-color: #ffffff;
      box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.32);
      position: absolute;
      left: 0;
      right: 0;
      margin: 0 auto;
      bottom: -58px;
      padding: 6px 0;

      .SMethod {
        font-family: SFProText-Regular;
        font-size: 13px;
        color: #000000;
        letter-spacing: -0.08px;
        line-height: 19px;
        padding: 7px 12px;
        cursor: pointer;

        &:hover {
          background-color: #e7edf1;
        }
      }
    }
  }

  .ModalStorySuccess {
    width: 300px;
    height: 174px;

    .StoryCamIcon {
      width: 40px;
      height: 40px;
      background-repeat: no-repeat;
      background-position: center;
      background-image: url(../assets/st.svg);
      margin: 29px auto 6px;
    }

    span {
      display: block;
      font-family: SFProText-Regular;
      font-size: 15px;
      color: #000000;
      letter-spacing: -0.21px;
      text-align: center;
      line-height: 19px;
    }

    button.BClose {
      font-family: SFProText-Regular;
      font-size: 12.5px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      padding: 7px 16px 8px;
      background-color: #5181b8;
      border-radius: 4px;
      display: block;
      margin: 25px auto;
    }
  }

  button.Share {
    background-color: #5181b8;
    padding: 7px 27px 8px 16px;
    border-radius: 4px;
    font-family: SFProText-Regular;
    font-size: 12.5px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    position: relative;

    &:hover {
      background-color: #5b88bd;
    }

    &:before {
      content: "";
      position: absolute;
      background-repeat: no-repeat;
      background-position: center;
      background-image: url(../assets/sharejnc.svg);
      width: 8px;
      height: 12px;
      right: 14px;
      top: 13px;
    }
  }

  button.ShareMobile {
    display: none;
  }

  .Title {
    font-family: MabryPro-Black;
    font-size: 21px;
    color: #222222;
    letter-spacing: 0;
    text-align: center;
    margin-top: 31px;
    text-transform: uppercase;
  }

  .Info {
    font-family: Helvetica;
    font-size: 14px;
    color: #656565;
    letter-spacing: 0;
    text-align: center;
    line-height: 19px;
    margin: 10px auto;
    width: 530px;
  }

  .Options {
    width: 100%;
    padding: 14px 0 0;

    .Option {
      width: 610px;
      height: 120px;
      margin: 15px auto;
      border-radius: 8px;
      // background-color: #ffe201;
      transition: 0.1s;
      color: #000000;
      display: flex;
      position: relative;

      .Img {
        width: 120px;
        height: 100%;
        // background-color: #000;
        float: left;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 80%;
      }

      .InfoBlock {
        height: 100%;

        .OTitle {
          margin-top: 19px;
          font-family: MabryPro-Bold;
          font-size: 17px;
          letter-spacing: 0;
          text-align: left;
        }

        .ODescr {
          font-family: MabryPro-Regular;
          font-size: 14px;
          letter-spacing: 0;
          text-align: left;
          line-height: 18px;
          margin-top: 8px;
          max-width: 365px;
        }

        .SelectCheckBoxMobile,
        .ReslutBoxMobile {
          display: none;
        }
      }

      .SelectCheckBox {
        width: 24px;
        height: 24px;
        background-color: #f2f4f8;
        border: 1px solid rgba(0, 0, 0, 0.08);
        border-radius: 4px;
        position: absolute;
        right: 24px;
        top: 48px;
        transition: 0.1s;
      }

      .ReslutBox {
        display: flex;
        position: absolute;
        right: 20px;
        height: 100%;
        text-align: right;

        .Reslut {
          margin: auto;

          .Percent {
            font-family: MabryPro-Bold;
            font-size: 20px;
            letter-spacing: 0;
            margin-bottom: 2px;
          }

          .Rate {
            margin-top: 2px;
            font-family: SFProText-Medium;
            font-size: 12px;
            letter-spacing: 0;
            text-align: right;
          }
        }
      }

      &:hover {
        .SelectCheckBox {
          background-color: #f2f4f8;
        }
      }

      &[selected] {
        .SelectCheckBox {
          right: 34px;
          // transform: translateX(-10px);
          background-color: #0102f8;
          border-color: transparent;
          background-image: url(../assets/check-w.svg);
          background-repeat: no-repeat;
          background-position: center;
          background-size: auto;
        }
      }

      &[blue] {
        color: #ffffff;

        &[selected] {
          .SelectCheckBox {
            background-color: #f2f4f8;
            background-image: url(../assets/check-b.svg);
          }
        }
      }
    }

    &[selectable] {
      .Option {
        cursor: pointer;

        &[selected] {
          padding: 0 10px;
        }
      }
    }
  }

  .Actions {
    button.Vote,
    button.Stickers {
      font-family: MabryPro-Black;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      line-height: 42px;
      background-color: #0000f6;
      border-radius: 32px;
      margin: 32px auto;
      display: block;
      text-transform: uppercase;
      // height: 48px;

      &:hover {
        background-color: #2b2bff;
      }
    }

    button.Vote {
      width: 243px;

      &:disabled {
        background-color: #cecedf;
        cursor: default;
      }
    }

    button.Stickers {
      width: 210px;
    }
  }

  @media screen and (max-width: 659px) {
    padding-top: env(safe-area-inset-top);
    padding-top: constant(safe-area-inset-top);
    padding-bottom: env(safe-area-inset-top);
    padding-bottom: constant(safe-area-inset-top);

    &[s] {
      padding-bottom: calc(env(safe-area-inset-top) + 77px);
      padding-bottom: calc(constant(safe-area-inset-top) + 77px);
    }

    .Modal {
      .MBox {
        position: absolute;
        bottom: 0;
        width: 100%;
        border-radius: 14px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        padding-bottom: env(safe-area-inset-bottom);
        padding-bottom: constant(safe-area-inset-bottom);

        .MClose {
          width: 48px;
          height: 48px;
          right: 0;
          top: 2px;
          background-image: url(../assets/close-m.svg);
        }

        .MTitle {
          color: #000000;
          max-width: 73%;
          margin: 22px auto 19px;
        }

        .MSnippetBox {
          position: relative;
          height: fit-content;
          width: calc(100% - 32px);
          // background-size: cover;

          &::before {
            content: "";
            padding-top: 50%;
            display: block;
          }
        }
      }
    }

    .ModalShare {
      height: fit-content;

      button.Share {
        display: none;
      }

      button.ShareMobile {
        display: block;
        margin: 12px auto 16px;
        width: calc(100% - 32px);
        font-family: SFProText-Medium;
        font-size: 17px;
        color: #ffffff;
        letter-spacing: -0.41px;
        text-align: center;
        border-radius: 10px;
        background-color: #5181b8;
        padding: 12px;

        &:hover {
          background-color: #5b88bd;
        }
      }
    }

    .SelectShareMethodMobile {
      display: block;
      user-select: none;
      z-index: 1;
      height: fit-content;
      margin: auto;
    }

    .SelectShareMethodMobile:not([ios]) {
      background-color: #ffffff;
      box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.22),
        0 24px 24px 0 rgba(0, 0, 0, 0.3);
      width: calc(280px - 16px);
      padding: 8px 0;
      border-radius: 12px;

      .SHMethods {
        div {
          padding: 14px calc(16px + 8px);
          font-family: Helvetica;
          font-size: 16px;
          color: #000000;
          text-align: left;
          line-height: 20px;

          &:active {
            background-color: #e0e0e0;
          }
        }
      }

      .SHCancel {
        display: none;
      }
    }

    .SelectShareMethodMobile[ios] {
      bottom: 0;
      bottom: env(safe-area-inset-bottom);
      bottom: constant(safe-area-inset-bottom);
      margin: 0 auto;
      width: calc(100% - 20px);
      height: fit-content;
      position: absolute;
      padding: 10px;

      .SHMethods {
        height: fit-content;

        div {
          font-family: SFProDisplay-Regular;
          font-size: 20px;
          color: #2787f5;
          letter-spacing: 0.34px;
          text-align: center;
          line-height: 24px;
          padding: 16px 0 17px;
          background-color: rgba(248, 248, 248, 0.87);
          border-top: 1px solid rgba(0, 0, 0, 0.12);

          &:first-child {
            border: none;
            border-top-left-radius: 14px;
            border-top-right-radius: 14px;
          }

          &:last-child {
            border-bottom-left-radius: 14px;
            border-bottom-right-radius: 14px;
          }

          &:active {
            opacity: 0.96;
          }
        }
      }

      .SHCancel {
        font-family: SFProDisplay-Regular;
        //font-family: SFProDisplay-Semibold;
        font-size: 20px;
        color: #2787f5;
        letter-spacing: 0.34px;
        text-align: center;
        line-height: 24px;
        background-color: #ffffff;
        border-radius: 14px;
        padding: 16px;
        margin: 8px auto 0;

        &:active {
          opacity: 0.96;
        }
      }
    }

    .Title {
      font-size: 24px;
      color: #2c2d2e;
      letter-spacing: 0;
      line-height: 30px;
      max-width: 343px;
      margin: 55px auto 0;
      display: block;
    }

    .Info {
      font-size: 16px;
      color: #76787a;
      letter-spacing: 0;
      line-height: 21px;
      max-width: 343px;
      width: auto;
      margin-bottom: 4px;
    }

    .Actions {
      position: fixed;
      width: 100%;
      bottom: 0;
      background-color: #ffffff;
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.12);
      border-top: 1px solid #e0e0e0;
      display: none;
      /* padding-bottom: calc(env(safe-area-inset-top) - 16px);
      padding-bottom: calc(constant(safe-area-inset-top) - 16px); */
      padding-bottom: env(safe-area-inset-bottom);
      padding-bottom: constant(safe-area-inset-bottom);

      &[mshow] {
        display: block;
      }

      button.Vote,
      button.Stickers {
        background-color: #5181b8 !important;
        margin: 16px;
        border-radius: 8px;
        // padding: 12px 0 13px;
        width: -webkit-fill-available;
        height: 44px;
        font-family: Helvetica;
        font-size: 16px;
        color: #ffffff;
        text-align: center;
        text-transform: none;
      }

      &[ios] button {
        font-family: SFProText-Medium;
        font-size: 17px;
        letter-spacing: -0.41px;
        border-radius: 10px;
        margin: 12px 16px;
      }
    }

    .Options {
      .Option {
        width: calc(100% - 32px);
        margin: 12px auto;
        border-radius: 12px;
        height: auto;
        padding: 0 !important;
        display: block;

        .Img {
          width: calc(112px - 40px);

          // height: 112px;
          height: 100%;
          position: absolute;

          padding: 0px 10px;
          margin-left: 10px;
          background-size: contain;
          background-position-y: 16px;
        }

        .InfoBlock {
          margin-left: 112px;
          padding: 17px 16px 20px 0;

          .OTitle {
            margin-top: 0;
            font-size: 19px;
          }

          .QDescr {
            font-size: 15px;
            margin-top: 11px;
          }

          .SelectCheckBoxMobile {
            margin-top: 15px;
            display: block;
            width: fit-content;
            border: 1px solid;
            border-radius: 15px;
            font-family: Helvetica;
            font-size: 15px;
            letter-spacing: -0.17px;
            padding: 4px 12px 7px 12px;
          }

          .ReslutBoxMobile {
            margin-top: 15px;
            height: 30px;
            display: block;

            .Reslut {
              width: 100%;

              .Percent {
                font-family: MabryPro-Bold;
                font-size: 24px;
                letter-spacing: 0;
                float: left;
              }

              .Rate {
                margin-top: 6px;
                float: right;
                font-family: SFProText-Medium;
                font-size: 14px;
                letter-spacing: 0;
                text-align: right;

                #hicon {
                  margin-top: 0;
                }
              }
            }
          }
        }

        &[selected] {
          .SelectCheckBoxMobile {
            /* border-color: #0102f8 !important;
            background-color: #0102f8; */
            color: #fff !important;
          }

          &[blue] {
            .SelectCheckBoxMobile {
              border-color: #fff !important;
              background-color: #fff;
              color: #0102f8 !important;
            }
          }
        }

        .SelectCheckBox,
        .ReslutBox {
          display: none;
        }
      }
    }

    .StorySuccessMobile {
      display: block;
      position: relative;
      background-color: #fcfcfc;
      /* background-image: url(../assets/st-m.svg);
      background-repeat: no-repeat;
      background-position: center; */
      font-family: SFProText-Regular;
      text-align: center;
      font-size: 15px;
      color: #000000;
      letter-spacing: -0.24px;
      line-height: 19px;
      padding: 18px 0px 19px 24px;
      width: calc(100% - 16px - 24px);
      // height: 56px;
      margin: 8px auto;
      position: fixed;
      bottom: 0;
      bottom: env(safe-area-inset-bottom);
      bottom: constant(safe-area-inset-bottom);
      left: 0;
      right: 0;
      box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.08), 0 0 24px 0 rgba(0, 0, 0, 0.32);
      border-radius: 10px;
      opacity: 1;
      transition: 0.3s;

      &::before {
        content: "";
        width: 32px;
        height: 32px;
        background-image: url(../assets/st-m.svg);
        background-repeat: no-repeat;
        background-position: center;
        display: block;
        position: absolute;
        left: -190px;
        right: 0;
        top: 10px;
        margin: auto;
      }

      &[ehide] {
        opacity: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Vote.vue